import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { KibGrid, KibGridItem } from '@chewy/kib-layout-react'
import { DateUtils } from '@pbt/pbt-ui-components'

import { MessageStatus } from '~/constants/communications'
import { getRole } from '~/store/reducers/roles'
import type { ChatMessage } from '~/types'
import { getCurrentRole, isInternalNote } from '~/utils/communicationsUtils'

import MedicalLabel from './MedicalLabel'

import styles from './MessageHeader.module.scss'

const MessageHeader = ({
  message,
  isReadOnly,
  isClientCommunication,
  sender: senderProp,
}: {
  isClientCommunication: boolean
  isReadOnly: boolean
  message: ChatMessage
  sender: string
}) => {
  const { t } = useTranslation(['Common', 'Communications'])
  const {
    isMedical,
    status,
    senderTitleRoleId = '',
    sendingDate,
    transport,
    type,
  } = message
  const role = useSelector(getRole(senderTitleRoleId))
  const isDraft = status === MessageStatus.DRAFT
  const isInternalNoteMessage = isInternalNote(transport, type)

  const roleTitle = getCurrentRole(message, isClientCommunication, role)
  const showComma = roleTitle && senderProp
  const sender = `${senderProp}${showComma && ', '}${roleTitle}`

  return (
    <KibGrid className={styles.messageHeader} valign="center">
      <KibGridItem>
        <span className={styles.creatorInfo}>{sender}</span>
        {isInternalNoteMessage ? (
          <span className={styles.internalNoteLabel}>
            {t('Communications:MESSAGE_CARD.NOT_SENT_TO_PET_PARENTS')}
          </span>
        ) : (
          <MedicalLabel
            isDraft={isDraft}
            isMedical={isMedical}
            isReadOnly={isReadOnly}
          />
        )}
      </KibGridItem>
      <KibGridItem className={styles.date}>
        {DateUtils.formatDateWithHours(sendingDate)}
      </KibGridItem>
    </KibGrid>
  )
}

export default MessageHeader
